<template>
  <div id="family-info">
    <div class="head">
      <div class="robot">
        <img :src="require(`@/assets/images/common/${avatar}.png`)">
        客服{{name}}
      </div>
      <div class="reset" @click="reset">
        重填
        <img src="@/assets/images/common/reset.png">
      </div>
    </div>
    <div class="conversation" ref="conversation">
      <transition-group  name="van-slide-up">
        <div class="question" v-show="progress > 0" :key="1">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            您好！我是客服{{name}}~请让我稍微占用您两分钟的时间来了解一下您的家庭情况~         
          </div>
        </div>
        <div class="question" v-show="progress > 1" :key="2">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            <p class="title">告诉{{name}}，您有哪些家庭成员呢</p>
            <ul class="item-list">
              <li :class="`item ${item.selected ? 'active':''}`" 
                v-for="(item, index) in baseMemberList" 
                :key="index"
                @click="progress == 2 ? selectMember(item) : ''">
                {{item.role_label}}
              </li>
              <li class="add-others" @click="addInput = true">
                <img src="@/assets/images/memberInfo/add.png" />
                其他
              </li>
            </ul>
            <div class="other" v-if="addInput">
              <input type="text" v-model="otherMember" placeholder="请输入其他成员的称呼">
              <button @click="addOtherMember">确定</button>
            </div>
            <button v-show="progress == 2" @click="nextStep(2)">选好了</button>
          </div>
        </div>
        <div class="question" :key="3"
        v-show="progress > 2 && (baseMemberList[2].selected || baseMemberList[3].selected)" >
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            <p class="title">您的子女数量？</p>
            <ul class="item-list">
              <li class="item active" v-if="baseMemberList[2].selected" @click="progress == 3 ? showPopup('amount','son') : ''">
                {{son}}个儿子
              </li>
              <li class="item active" v-if="baseMemberList[3].selected" @click="progress == 3 ? showPopup('amount','daughter') :''">
                {{daughter}}个女儿
              </li>
            </ul>
            <button v-show="progress == 3" @click="nextStep(3)">选好了</button>      
          </div>
        </div>
        <div class="question" v-show="progress > 3" :key="4">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            <p class="title">您想要为谁投保呢？</p>
            <ul class="item-list">
              <li :class="`item ${item.selected ? 'active':''}`" 
                v-for="(item, index) in insureMemberList" 
                :key="index"
                @click="progress == 4 ? selectMember(item) : ''">
                {{item.role_label}}
              </li>
            </ul>
            <button v-show="progress == 4" @click="nextStep(4)">选好了</button>       
          </div>
        </div>
        <div class="question" v-show="progress > 4" :key="5">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            接下来~ 需要您填写下被保人的信息哦~         
          </div>
        </div>
        <div class="question" v-show="progress > 5" :key="6">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content" id="dwallindex">
            <div v-for="(item, index) in insureMemberInfo" :key="index">
              <p class="title">{{insurelabelList[index]}}</p>
              <div class="info">
                <div class="normal">
                  <label>真实姓名</label>
                  <input  @blur.prevent="inputBlur" v-model="item.real_name" placeholder="请输入真实姓名"  />
                </div>
                <div class="normal">
                  <label>性别</label>
                  <!-- <input  @blur.prevent="inputBlur" v-model="item.sex" placeholder="请输入性别"  /> -->
                  <input @click="progress == 6 ? showPopup('sex',item) : ''" v-model="sexarr[item.gender - 1]"  type="text" placeholder="请选择 >" readonly/>
                </div>
                <div class="normal">
                  <label>出生日期</label>
                  <input @click="progress == 6 ? showPopup('birthday',item) : ''" v-model="item.birthday" type="text" placeholder="请选择 >" readonly/>
                </div>
                <div class="normal" v-if="item.role != 3 && item.role != 4">
                  <label>职业</label>
                  <input  @blur.prevent="inputBlur" v-model="item.occupation" placeholder="请输入职业名称"  />
                  <!-- <input @click="progress == 6 ? showPopup('occupation',item) : ''" v-model="occupation[item.occupation - 1]" type="text" placeholder="请选择 >" readonly/> -->
                </div>
                <div class="big situation">
                  <p>
                    <label>保障情况</label>
                  </p>
                  <div class="contain">
                    <span v-for="(ele, i) in item.protection" :key="i">
                      {{protection[ele]}}
                      <img
                        src="@/assets/images/memberInfo/delete.png"
                        @click="progress == 6 ? deleteItem(item.protection, i) : ''"
                      />
                    </span>
                    <i class="add" @click="progress == 6 ? showPopup('protection',item) : ''">
                      <img src="@/assets/images/memberInfo/add.png" />
                      添加
                    </i>
                  </div>
                </div>
                <div class="big situation">
                  <p>
                    <label>疾病情况</label>
                  </p>
                  <div class="contain">
                    <span v-for="(ele, i) in item.new_disease" :key="i">
                      {{disease[ele]}}
                      <img
                        src="@/assets/images/memberInfo/delete.png"
                        @click="progress == 6 ? deleteItem(item.new_disease, i) :''"
                      />
                    </span>
                    <i class="add" @click="progress == 6 ? showPopup('disease',item) : ''">
                      <img src="@/assets/images/memberInfo/add.png" />
                      添加
                    </i>
                  </div>
                </div>
              </div> 
            </div>
            <button v-show="progress == 6" @click="nextStep(6)">填好了</button>         
          </div>
        </div>
        <div class="question"  v-show="progress > 6" :key="7">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            最后~ {{name}}要了解一下您的家庭经济情况~
          </div>
        </div>
        <div class="question"  v-show="progress > 7" :key="8">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            <p class="title">家庭经济情况</p>
              <div class="info">
                <div class="normal income">
                  <label>您的家庭收入情况</label>
                  <input @click="progress == 8 ? showPopup('income') :''" v-model="familyNeed.income" type="text" placeholder="请选择 >" readonly/>
                </div>
                <div class="normal budget">
                  <label>您本次保险规划的预算</label>
                  <input @click="progress == 8 ? showPopup('budget') :''" v-model="familyNeed.budget" type="text" placeholder="请选择 >" readonly/>
                </div>
                <div class="tip">
                  <img src="@/assets/images/common/i.png">
                  合理保费预算在家庭收入中的占比为10%~15%左右</div>
                <div class="normal">
                  <label for="tel">手机号</label>
                  <input id="tel" type="number" @blur.prevent="inputBlur" v-model="familyNeed.telephone" placeholder="请输入手机号"/>
                </div>
                <div class="normal">
                  <label for="code">验证码</label>
                  <input id="code" v-model="code" type="number" placeholder="请输入验证码" @blur.prevent="inputBlur" />
                  <button @click="progress == 8 ? getCode() :''" :disabled="btnDisabled">{{getCodeBtn}}</button>
                </div>
              </div>
            <button v-show="progress == 8" @click="nextStep(8)">填好了</button>
          </div>
        </div>
        <div class="question"  v-show="progress > 8" :key="9">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            好的~ {{name}}收到您的信息啦~
          </div>
        </div>
        <div class="question"  v-show="progress > 9" :key="10">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            {{name}}已经将您的信息成功提交啦~
          </div>
        </div>
        <div class="question"  v-show="progress > 10" :key="11">
          <img class="avatar" :src="require(`@/assets/images/common/${avatar}.png`)">
          <div class="content">
            那我们待会见啦~ 🙂🙂
          </div>
        </div>
      </transition-group>
    </div>

    <van-popup position="bottom" v-model="popupControl.amount">
      <van-picker
        show-toolbar
        title="数量"
        :columns="[1,2,3,4,5]"
        @cancel="closePopup('amount')"
        @confirm="onAmountConfirm"
      />
    </van-popup>

    <van-popup position="bottom" v-model="popupControl.birthday">
      <van-datetime-picker
        v-model="datetimePicker.currentDate"
        type="date"
        :min-date="datetimePicker.minDate"
        :max-date="datetimePicker.maxDate"
        @cancel="closePopup('birthday')"
        @confirm="onBirthdayConfirm"
      />
    </van-popup>

    <!-- <van-popup position="bottom" v-model="popupControl.occupation">
      <van-picker
        show-toolbar
        title="职业"
        :columns="occupation"
        @cancel="closePopup('occupation')"
        @confirm="onOccupationConfirm"
      />
    </van-popup> -->
    <van-popup position="bottom" v-model="popupControl.sex">
      <van-picker
        show-toolbar
        title="性别"
        :columns="sexarr"
        @cancel="closePopup('sex')"
        @confirm="onsexConfirm"
      />
    </van-popup>

    <transition-group  name="van-slide-up">
      <div v-show="popupControl.disease" class="diseaseul" :key="1">
        <div>
          <span class="van-picker__cancel" @click="closePopup('disease')">取消</span>
          <span class="van-ellipsis van-picker__title">添加疾病情况</span>
          <span class="van-picker__confirm" @click="onDiseaseConfirm">确定</span>
        </div>
        <ul >
          <li :attr="item"   @click="choseitem(item)" v-for="(i,item) in disease" :key="item" :class="items.indexOf(item) != -1 ? 'active':''">{{i}}</li>
        </ul>
      </div>

      <div v-show="popupControl.protection" class="diseaseul" :key="2">
        <div>
          <span class="van-picker__cancel" @click="closePopup('protection')">取消</span>
          <span class="van-ellipsis van-picker__title">添加保障情况</span>
          <span class="van-picker__confirm" @click="onProtectionConfirm">确定</span>
        </div>
        <ul >
          <li :attr="proitem[item]"  @click="choseite2(item)" v-for="(i,item) in protection" :key="item" :class="proitem.indexOf(item) != -1 ? 'active':''">{{i}}</li>
        </ul>
      </div>
    </transition-group>

    <!-- <van-popup position="bottom" v-model="popupControl.protection">
      <van-picker
        show-toolbar
        title="添加保障情况"
        :columns="protection"
        @cancel="closePopup('protection')"
        @confirm="onProtectionConfirm"
      />
    </van-popup>

    <van-popup position="bottom" v-model="popupControl.disease">
      <van-picker
        show-toolbar
        title="添加疾病情况"
        :columns="disease"
        @cancel="closePopup('disease')"
        @confirm="onDiseaseConfirm"
      />
    </van-popup> -->

    <van-popup position="bottom" v-model="popupControl.income">
      <van-picker
        show-toolbar
        title="家庭收入"
        :columns="income"
        @cancel="closePopup('income')"
        @confirm="onIncomeConfirm"
      />
    </van-popup>

    <van-popup position="bottom" v-model="popupControl.budget">
      <van-picker
        show-toolbar
        title="预算"
        :columns="budget"
        @cancel="closePopup('budget')"
        @confirm="onBudgetConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
// 家庭信息
export default {
  name: 'familyInfo',
  data(){
    return {
      proitem:[],
      items:[],
      name: '锦妹',
      avatar: 'sister',
      progress: 1,

      // 儿子/女儿数量以及删除时的备份
      son: 1,
      daughter: 1,
      sonBak:[],
      daughterBak:[],
      // 验证码
      getCodeBtn: '获取验证码',
      btnDisabled: false,
      code: '',
      // 添加其他成员
      addInput: false,
      otherMember: '',

      // 需要显示的数据
      sexarr:['男','女'],
      allMember: ['本人','配偶','儿子','女儿','父亲','母亲','配偶父亲','配偶母亲','其他'],
      occupation: ['室内轻体力（行政、管理人员）', '室内中体力（程序员）', '户外简单工作（导游、司机）', '户外复杂工作（工程师、建筑工人）', '室内制造业（装修、流水线工人）', '家庭主妇', '其他'],
      disease:['无','住院','手术','门诊','体检'],
      // disease: ['无', '其他', 'BMI偏高', 'BMI偏低', '高血压', '肺气肿', '慢性支气管炎', '肺结核', '哮喘', '肺炎', '肺纤维化', '肺结节',
      //   '乙肝-大三阳', '乙肝-小三阳', '乙肝病毒携带', '甲状腺结节', '甲状腺功能亢进', '甲状腺功能减退', '乳腺增生', '乳腺结节',
      //   '胆囊息肉', '肾囊肿', '肾结石', '肾炎', '子宫肌瘤', '卵巢囊肿', '宫颈炎', '孕期28周内', '孕期28周后', '轻度脂肪肝',
      //   '中度脂肪肝', '重度脂肪肝', '结节/息肉/囊肿等赘生物', '近两年有住院史或体检异常', '为2周岁以下婴儿（是否早产）',
      //   '心脑血管疾病', '良性肿瘤', '精神类疾病（抑郁症/焦虑症/焦躁症等）', '吸毒史/艾滋病患者', '甲型肝炎/丙型肝炎',
      //   '高血脂', '高血糖'],
      protection: ['无', '其他', '社保（包含新农合）', '重疾险', '寿险', '医疗险', '意外险', '防癌险', '年金险', '理财险'],
      income:[],
      budget:[
        {
          values: ['1','2','3','4','5','6','7','8','9','10'],
          defaultIndex: 0
        },
        {
          values: ['千','万'],
          defaultIndex: 0
        }
      ],

      // 弹出框控制和设置
      nowPopup:{

      },
      popupControl: {
        amount: false,
        birthday: false,
        // occupation: false,
        protection: false,
        disease: false,
        income: false,
        budget: false,
        sex:false,
      },
      datetimePicker: {
        minDate: new Date(1920, 0, 1),
        maxDate: new Date(2025, 12, 31),
        currentDate: new Date(),
      },

      // 数据
      userBaseInfo:{},
      familyMemberList:{},
      baseMemberList:[],
      insureMemberList:[],
      insurelabelList:[],
      insureMemberInfo:[],
      familyNeed:{
        user_family_ids:[],
        income: '',
        budget: '',
        telephone: '',
      },
      falsenode:''
    }
  },
  methods:{
     choseitem(item){
      // 点击取消
      if(item == 0){
        if(this.items[0] == 0 && this.items.length == 1){
            this.items = []
        }else if(this.items.length){
          this.$dialog.confirm({
            title: '提示',
            message: '选择无后其他疾病将无法选择，是否确定选择？',
          }).then(() => {
            this.items = [];
            this.$set(this.items,0,0)
          }).catch(() => {
            
          });
        }else{
          this.items = [];
          this.$set(this.items,0,0)
        }
      }else if(this.items.indexOf(item) == -1){
        if(this.items.indexOf(0) != -1 || this.items.indexOf('0') != -1){
          this.items = []
          this.$set(this.items,item,item)
          // this.$toast('您已添加过无，不能再添加其余选项了哦')
        }else{
          this.items.push(item)
        }
      }else{
        this.proitem.forEach((newitem,index)=>{
          if(newitem == item){
            this.$set(this.items,index,'')
          }
        })
      }
    },
    choseite2(item){
      if(item == 0){
        if(this.proitem[0] == 0 && this.proitem.length == 1){
            this.proitem = []
        }else if(this.proitem.length){
          this.$dialog.confirm({
            title: '提示',
            message: '选择无后其他保障将无法选择，是否确定选择？',
          }).then(() => {
            this.proitem = [];
            this.$set(this.proitem,0,0)
          }).catch(() => {
            
          });
        }else{
          this.proitem = [];
          this.$set(this.proitem,0,0)
        }
      }else if(this.proitem.indexOf(item) == -1){
        if(this.proitem.indexOf(0) != -1 || this.proitem.indexOf('0') != -1){
          this.proitem = []
          this.$set(this.proitem,item,item)
          // this.$toast('您已添加过无，不能再添加其余选项了哦')
        }else{
          this.proitem.push(item)
        }
      }else{
        this.proitem.forEach((newitem,index)=>{
          if(newitem == item){
            this.$set(this.proitem,index,'')
          }
        })
      }
      // console.log(this.proitem,this.nowPopup)
    },
    // 解决ios键盘收起页面还在上方的问题
    inputBlur(){
      scrollTo(0, pageYOffset)
    },
    // 重填
    reset(){
      location.reload()
    },
    // 添加其他成员
    addOtherMember(){
      if(this.otherMember.replace(" ","") == ''){
        this.$toast('称呼不能为空哦')
        this.otherMember = ''
      }else{
        this.baseMemberList.push({
          role: 9,
          role_label: this.otherMember,
          selected: true,
          ids: []
        })
        this.otherMember = ''
        this.addInput = false
      }
    },
    // 生成收入选择数组
    creatIncomeList(){
      for(let i = 0; i <= 100; i+=5 ){
        this.income.push(`${i}万`)
      }
    },
    // 生成第一步显示的列表
    creatBaseMemberList(){
      this.baseMemberList = []
      for(let i = 0; i < this.allMember.length - 1; i++){ //去掉了其他
        this.baseMemberList.push({
          role: i + 1,
          role_label: this.allMember[i],
          selected: false,
          ids: []
        })
      }
    },
    // 生成要为谁投保的列表
    createInsureMemberList(){
      this.insureMemberList = []
      let insureMember = this.insureMemberList
      this.baseMemberList.forEach(item => {
        // console.log(item,'----')

        if(item.selected){
          if(item.role == 3){//儿子
            for(let i = 0; i < item.ids.length; i++ ){
              let obj = {
                id: item.ids[i],
                role: item.role,
                role_label: `儿子${i+1}`,
                selected: false
              }
              insureMember.push(obj)
            }
          }else if(item.role == 4){//女儿
            for(let i = 0; i < item.ids.length; i++ ){
              let obj = {
                id: item.ids[i],
                role: item.role,
                role_label: `女儿${i+1}`,
                selected: false
              }
              insureMember.push(obj)
            }
          }else{
            let obj = {
              id: item.ids[0],
              role: item.role,
              role_label: item.role_label,
              selected: false
            }
            insureMember.push(obj)
          }
        }  
      })
    },
    // 生成填写信息的数据
    createInsureMemberInfo(){
      this.insureMemberInfo = []
      this.insurelabelList = []
      let info = this.insureMemberInfo
      let baseInfo = this.familyMemberList
      this.insureMemberList.forEach(item => {
        if(item.selected){
          let disease = baseInfo[item.id] && baseInfo[item.id].new_disease != '' ? baseInfo[item.id].new_disease.split(','): []
          let protection = baseInfo[item.id] && baseInfo[item.id].protection != '' ? baseInfo[item.id].protection.split(',') : [] 
          let obj = {
            id: item.id || '',
            role: item.role,
            role_label: item.role_label,
            birthday: baseInfo[item.id] ? baseInfo[item.id].birthday : '',
            real_name: baseInfo[item.id] ? baseInfo[item.id].real_name : '',
            occupation: baseInfo[item.id] ? baseInfo[item.id].occupation : '',
            gender: baseInfo[item.id] ? baseInfo[item.id].gender : 1,
            // occupation: item.occupation,
            new_disease: disease,
            protection: protection,
          }
          info.push(obj)
          this.insurelabelList.push(item.role_label)
          // console.log(baseInfo[item.id],'132456')
        }
      })
    },
    // 设置默认选中
    initDefaultSelected(){
      this.baseMemberList.forEach(element => {
        for(let i in this.familyMemberList){
          if(this.familyMemberList[i].role == element.role){
            element.selected = true
            element.ids.push(i)
          }
        }
      })
      
      for(let i in this.familyMemberList){
        if(this.familyMemberList[i].role == 9){
          this.baseMemberList.push({
            role: 9,
            role_label: this.familyMemberList[i].role_label,
            selected: true,
            ids: [i]
          })
        }
      }

      if(this.baseMemberList[2].ids.length){
        this.son = this.baseMemberList[2].ids.length
      }else{
        this.son = 1;
        this.baseMemberList[2].ids.push('')
      }
      if(this.baseMemberList[3].ids.length){
        this.daughter = this.baseMemberList[3].ids.length
      }else{
        this.daughter = 1;
        this.baseMemberList[3].ids.push('')
      }
    },
    // popup开关
    showPopup(type, target){
      this.nowPopup = target || ''
      if(type == 'protection'){
        this.proitem =JSON.parse(JSON.stringify(target)).protection;
        this.proitem = this.proitem.map(Number)
      }else if(type == 'disease'){
        this.items = JSON.parse(JSON.stringify(target)).new_disease;
        this.items = this.items.map(Number)
      }
      this.popupControl[type] = true
    },
    closePopup(type){
      this.popupControl[type] = false
      if(type == 'protection'){
        this.proitem = [];
      }else if(type == 'disease'){
        this.item = [];
      }
    },
    // popup确认
    onAmountConfirm(value){
      this.popupControl.amount = false
      let difference = Math.abs( value - this[this.nowPopup] )  //相差的数量
      let change = value > this[this.nowPopup] ? true : false //true 增加 false 减少
      this.childNumberChange(difference, change)
      this[this.nowPopup] = value
    },
    childNumberChange(difference, change){
      if(difference != 0 ){
        let index = this.nowPopup == 'son' ? 2 : 3
        let ids = this.baseMemberList[index].ids
        let bak = this[`${this.nowPopup}Bak`]
        if(change){
          //增加数量
          if(bak){ // 有备份
            ids.push(bak[0])
            bak.shift()
            difference --
            this.childNumberChange(difference, change)
          }else{ //无备份 新增空id
            ids.push('')
            difference --
            this.childNumberChange(difference, change)
          }
        }else{
          //数量减少
          bak.push(ids[ids.length-1])
          ids.pop()
          difference --
          this.childNumberChange(difference, change)
        }
      }else{
        return
      }
      
    },
    onBirthdayConfirm(value){
      let date = this.Global.formatDate(value)
      this.nowPopup.birthday = date
      this.closePopup('birthday')
    },
    onOccupationConfirm(value, index){
      this.nowPopup.occupation = index + 1
      this.closePopup('occupation')
    },
    onsexConfirm(value,index){
      this.nowPopup.gender = index + 1
      this.closePopup('sex')
    },

    onProtectionConfirm(){
      this.nowPopup.protection = [];
      for(var i in this.proitem){
        if(this.proitem[i] || this.proitem[i] === 0){
          this.nowPopup.protection.push(this.proitem[i])
        }
      }
      this.proitem = [];
      this.closePopup('protection')
    },
    onDiseaseConfirm(){
      this.nowPopup.new_disease = [];
      for(var i in this.items){
        if(this.items[i] || this.items[i] === 0){
          this.nowPopup.new_disease.push(this.items[i])
        }
      }
      this.items = [];
      this.closePopup('disease')
    },
    onIncomeConfirm(value){
      this.familyNeed.income = value
      this.closePopup('income')
    },
    onBudgetConfirm(value){
      this.familyNeed.budget = `${value[0]}${value[1]}`
      this.closePopup('budget')
    },
    // 删除选项
    deleteItem(arr, i){
      arr.splice(i,1)
    },
    // 控制下一步
    nextStep(progress){
      switch (progress){
        case 2://家庭成员
          if(this.verify(2)){
            this.addInput = false
            if(this.baseMemberList[2].selected || this.baseMemberList[3].selected){
              this.addprogress(1)
            }else{
              this.createInsureMemberList()
              this.addprogress(2, true)
            }
          }
          break
        case 3://子女数量
          this.createInsureMemberList()
          this.addprogress(1)
          break
        case 4://为谁投保
          if(this.verify(4)){
            this.createInsureMemberInfo()
            this.addprogress(2)
          }
          break
        case 6:
          if( this.verify(6) ){
            this.saveFamilyMemberInfo()
          }
          break
        case 8:
          if( this.verify(8) ){
            this.verifyCode()
          }
          break
        default:
          return
      }
    },
    // 进度增加
    addprogress(n, noInterval){
      if(noInterval){
        this.progress += n
      }else if( n > 1){
        let target = this.progress + n 
        this.progress += 1
        let interval = setInterval(() => {
          if(this.progress < target){
            this.progress += 1
            if(this.progress == 11){
              setTimeout(()=>{
                this.$router.push('/personal')
              }, 2500)
            }
          }else{
            clearInterval(interval)
          }
        }, 1500)
      }else{
        this.progress += 1
      }
    },
    // 添加进度时滚动到底部
    scrollToBottom(){
      // console.log(this.progress)
      if(this.progress == 6){
        this.$nextTick(() => {
          let ele = this.$refs.conversation
          ele.scrollTop = document.getElementsByClassName("question")[0].offsetHeight +  document.getElementsByClassName("question")[1].offsetHeight + document.getElementsByClassName("question")[2].offsetHeight+ document.getElementsByClassName("question")[3].offsetHeight+ document.getElementsByClassName("question")[4].offsetHeight+ document.getElementsByClassName("head")[0].offsetHeight
        })
      }else{
        this.$nextTick(() => {
          let ele = this.$refs.conversation
          ele.scrollTop = ele.scrollHeight
        })
      }
    },
    // 选择成员
    selectMember(item){
      item.selected = !item.selected
    },
    // 短信发送倒数
    countdown(){
      let timer = null,
        s = 120
      clearInterval(timer);
      this.btnDisabled = true
      if (!this.btnDisabled) return;
      timer = setInterval( () => {
        s--
        if (s >= 0) {
          this.getCodeBtn = `剩余${s}秒`
        } else {
          this.getCodeBtn = '重新发送'
          this.btnDisabled = false
          clearInterval(timer)
          s = 120
        }
      }, 1000)
    },
    // 验证手机号
    verifyTel(){
      return /^1\d{10}$/.test(this.familyNeed.telephone)
    },
    // 每个步骤的验证
    verify(progress){
      switch (progress){
        case 2: {//家庭成员
          let memberEmpty = true
          this.baseMemberList.forEach(item => {
            if(memberEmpty){
              memberEmpty = item.selected ? false : true
            }
          })
          if(memberEmpty){
            this.$toast('请至少选择一位家庭成员哦')
            return false
          } 
          break
        }
        case 3:  //子女数量

          break
        case 4: {//为谁投保
          let insureEmpty = true
          this.insureMemberList.forEach(item => {
            if(insureEmpty){
              insureEmpty = item.selected ? false : true
            }
          })
          if(insureEmpty){
            this.$toast('请至少选择一位投保成员哦')
            return false
          } 
          break
        }
        case 6: {
          if(this.falsenode){
            this.falsenode.style.backgroundColor = "#fff5eb"
            this.falsenode.style.borderRadius = "0"
          }
          for(let i = 0; i < this.insureMemberInfo.length; i++){
            let data = this.insureMemberInfo[i]
            let label = this.insurelabelList[i]
            if(!data.real_name){
              this.$toast(`请输入${label}的真实姓名`)
              this.totow(i,0,data.role);
              return false
            }
            if(!data.gender){
              this.$toast(`请输入${label}的性别`)
              this.totow(i,1,data.role);
              return false
            }
            if(!data.birthday){
              this.$toast(`请选择${label}的出生日期`)
              this.totow(i,2,data.role);
              return false
            }
            if(data.role != 3 && data.role != 4){
              if(!data.occupation){
                this.$toast(`请输入${label}的职业`)
                this.totow(i,3,data.role);
                return false
              }
            }
            if(data.protection.length == 0){
              this.$toast(`请添加${label}的保障情况`)
              this.totow(i,4,data.role);
              return false
            }
            if(data.new_disease.length == 0){
              this.$toast(`请添加${label}的疾病情况`)
              this.totow(i,5,data.role);
              return false
            }
          }
          break
        }
        case 8: {
          if( !this.familyNeed.income ){
            this.$toast('请填写家庭收入情况')
            return false
          }
          if( !this.familyNeed.budget ){
            this.$toast('请选择规划预算')
            return false
          }
          if( !this.familyNeed.telephone ){
            this.$toast('请输入手机号码')
            return false
          }
          if( !this.code ){
            this.$toast('请输入验证码')
            return false
          }
          if( !/^\d{6}$/.test(this.code) ){
            this.$toast('验证码必须为6位数字')
            return false
          }
          break
        }
      }
      return true
    },
    totow(ite,inde,roal){
      if((roal == 3 || roal == 4) && (inde == 4 || inde == 5)){
        inde = inde - 1;
      }
      document.getElementById("#dwallindex")
      this.falsenode = document.getElementById("dwallindex").children[ite].children[1].children[inde];
      let ele = this.$refs.conversation;
      // this.falsenode.style.borderColor = "#fd0000"
      this.falsenode.style.backgroundColor = "#ffe1c5"
      this.falsenode.style.borderRadius = "0.5rem"
      ele.scrollTop = this.falsenode.offsetTop - document.getElementsByClassName('head')[0].offsetHeight-20;
    },
    // api
    // 获取验证码
    getCode(){
      if( this.verifyTel() ){
        this.axios({
          method: 'POST',
          url: '/sms/send',
          headers: {
            'Authorization': `Bearer ${this.Global.getCookie('token')}` 
          },
          data:{
            telephone: this.familyNeed.telephone
          }
        }).then((res) => {
          if(res.data.code == 0){
            this.$toast('验证码已发送')
            this.countdown()
          }else if(res.data.code == 50002){
            this.$toast('验证码发送频繁，请稍后再试')
          }
        })
      }else {
        this.$toast('请输入正确的手机号')
      }
    },
    // 验证验证码
    verifyCode(){
      this.axios({
        method: 'POST',
        url: '/sms/verify',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data:{
          telephone: this.familyNeed.telephone,
          code: this.code
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.saveFamilyNeed()
        }else if(res.data.code == 40022){
          let msg = ''
          for(let i in res.data.message){
            if (msg == ''){
              msg = res.data.message[i][0]
              this.$toast(msg)
            }
          }
        }else if(res.data.code == 40003){
          this.$toast(res.data.message)
        }else{
          this.$toast(res.data.message)
        }
      })
    },
    // 获取用户信息
    getUserInfo() {
      this.axios({
        method: 'GET',
        url: '/user',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.userBaseInfo = res.data.data
          this.Storage.set('userBaseInfo', res.data.data)
        }
      })
    },
    // 获取家庭信息列表
    getFamilyMemberList(){
      this.axios({
        method: 'GET',
        url: '/user-family?need=id,role,role_label,real_name,birthday,occupation,new_disease,protection,gender&collection_key=id',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.familyMemberList = res.data.data;
          this.initDefaultSelected() 
        }
      })
    },
    // 保存家庭信息
    saveFamilyMemberInfo(){
      let data = JSON.parse(JSON.stringify(this.insureMemberInfo))
      data.forEach(item => {
        item.new_disease = item.new_disease.join(',')
        item.protection = item.protection.join(',')
      })
      this.axios({
        method: 'POST',
        url: '/user-family/need/multi-family',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data: data
      }).then((res) => {
        if(res.data.code == 0){
          this.familyNeed.user_family_ids = res.data.data.user_family_ids
          this.familyNeed.telephone = res.data.data.telephone
          this.addprogress(2)
        }
      })
    },
    // 保存家庭需求信息
    saveFamilyNeed(){
      this.axios({
        method: 'POST',
        url: '/user-family/need',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data: this.familyNeed
      }).then((res) => {
        if(res.data.code == 0){
          this.addprogress(3)
        }
      })
    },
  },
  created(){
    this.Storage.session.set('denglu', false)
    // console.log('修改')
    let s_info = this.Storage.get('userBaseInfo')
    if(s_info){
      this.userBaseInfo = s_info
    }else{
      this.getUserInfo()
    }
    this.creatBaseMemberList()
    this.creatIncomeList()
    this.getFamilyMemberList()
    // 设置机器人头像
    this.name = this.userBaseInfo.gender == 1 ? '锦妹' : '鲤叔'
    this.avatar = this.userBaseInfo.gender == 1 ? 'sister' : 'uncle' 
    // 配置分享信息
    this.Global.getShareConfig({
      title: '快来了解自己和家人面临了哪些风险？',
      desc: '看看锦鲤如何为我们家庭保驾护航~'
    },this)
  },
  mounted(){
    this.addprogress(1)
  },
  watch:{
    progress: 'scrollToBottom',
  }
}
</script>

<style scoped>
.diseaseul>div{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f7f7f7;
  position: fixed;
  height: 2.5rem;
  width: 100%;
  background: white;
  }
.diseaseul ul{padding-top: 2.5rem;}
 .diseaseul{
    width: 100%;
    position: fixed;
    overflow: auto;
    bottom: 0;
    top: 0;
    background: white;}
.diseaseul li{    text-align: center;
    padding: 0.5rem;
    border: 1px solid #c7c7cc;
    border-radius: 1rem;
    margin: 0.5rem 0.5rem;
    color: #c7c7c7;}
.diseaseul .active{
  border: 1px solid rgba(255,161,39,1);
  background: rgba(255,161,39,1);
  color: white;
}
  #family-info{
    height: 100vh;
    overflow: hidden;
  }
  .head{
    height: 3.8125rem;
    padding: 0 1.1875rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FF9024;
    color: #fff;
    font-weight: 400;
  }
  .head > div{
    display: flex;
    align-items: center;
  }
  .head .robot{
    font-size: 1rem;
  }
  .head .robot img{
    width: 2.625rem;
    margin-right: 0.875rem;
  }
  .head .reset{
    font-size: 0.75rem;
  }
  .head .reset img{
    width: 0.875rem;
    margin-left: 0.4375rem;
  }
  .conversation{
    overflow-y: scroll;
    height: calc( 100vh - 3.8125rem);
    padding: 2.125rem 1.625rem 1.25rem 0.9375rem;
    scroll-behavior: smooth;
  }
  .conversation .question{
    display: flex;
    margin-bottom: 1.625rem;
  }
  .conversation .question .avatar{
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    margin-right: 1.1875rem;
    flex-shrink: 0;
  }
  .conversation .question .content{
    float: 1;
    width: 100%;
    background:#fff5eb;
    border-radius:0rem 0.875rem 0.875rem 0.875rem;
    padding: 0.9375rem;
    font-size: 0.875rem;
    line-height: 1.1875rem;
    color: #383838;
  }
  .conversation .question .content .title{
    font-weight: bold;
    margin-bottom: 1.1875rem;
  }
  .conversation .question .content > button{
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 1.25rem;
    margin-top: 1.25rem;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
  }
  .conversation .question .content .item-list{
    display: flex;
    flex-wrap: wrap;
  }
  .conversation .question .content .item-list .add-others,
  .conversation .question .content .item-list .item{
    width: 4.3125rem;
    height: 1.75rem;
    line-height: 1.625rem;
    margin: 0 0.3125rem 0.75rem;
    border: 1px solid #FF9024;
    color: #FF9024;
    border-radius: 0.875rem;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 400;
  }
  .conversation .question .content .item-list .item.active{
    background: #FF9024;
    color: #fff;
  }
  .conversation .question .content .item-list .add-others{
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .conversation .question .content .item-list .add-others img{
    width: 0.9375rem;
    margin-right: 0.2rem;
    margin-top: -0.0625rem;
  }
  .conversation .question .content .other{
    margin: 0.5rem 0.3125rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.75rem;
  }
  .conversation .question .content .other input{
    flex: 1;
    border-bottom: 1px solid #ff9024;
    padding: 0.1875rem 0.3125rem;
    border-radius: 0;
  }
  .conversation .question .content .other input::-webkit-input-placeholder {
    color: #999;
  }
  .conversation .question .content .other button{
    width: 3.2rem;
    border-radius: 0.875rem;
    color: #fff;
    padding: 0.1875rem 0;
    margin-left: 0.8rem;
  }

  .conversation .question .content .info{
    margin-bottom: 1.1875rem;
  }
  input {
    border: none;
    background: transparent;
  }
  input::-webkit-input-placeholder {
    color: #383838;
  }
  .conversation .question .content .normal {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(255,144,36,0.55);
    height: 2.5625rem;
    overflow: hidden;
  }
  .conversation .question .content .tip{
    font-size: 0.6875rem;
    color: #ff9024;
    margin-top: 0.5625rem;
    margin-bottom: 1.625rem;
    line-height: 0.9375rem;
    display: flex;
    align-items: flex-start;
  }
  .conversation .question .content .tip img{
    width: 0.75rem;
    margin-top: 0.125rem;
    margin-right: 0.1875rem;
  }
  .conversation .question .content .normal label {
    position: relative;
    max-width: 7.5rem;
    font-size: 0.75rem;
    font-weight: 400;
    color: #383838;
    flex-shrink: 0;
  }
  .conversation .question .content .income input,
  .conversation .question .content .budget input{
    width: 2rem;
  }
  .conversation .question .content .normal input{
    flex: 1;
    font-size: 0.75rem;
    font-weight: 400;
    color: #383838;
    text-align: right;
  }
  .conversation .question .content .big p {
    padding: 0.9375rem 0;
    font-size: 0.75rem;
    font-weight: 400;
    color: #383838;
  }
  .situation {
    border-bottom: 1px solid rgba(255,144,36,0.55);
  }
  .situation .contain {
    display: flex;
    flex-wrap: wrap;
  }
  .situation .contain span {
    display: inline-block;
    position: relative;
    margin-bottom: 1.1875rem;
    padding: 0 0.5625rem;
    height: 1.5625rem;
    line-height: 1.5625rem;
    border-radius: 0.75rem;
    background: #ff9024;
    color: #fff;
    font-size: 0.75rem;
    font-weight: 400;
    margin-right: 1rem;
  }
  .situation .contain span img {
    width: 0.5625rem;
    position: absolute;
    top: 0;
    right: 0;
  }
  .situation .contain .add {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    color: #ff9024;
    margin-bottom: 1.25rem;
    font-style: normal;
  }
  .situation .contain .add img {
    width: 0.75rem;
    margin-right: 0.3125rem;
  }
  #code{
    width: 4.6875rem;
    text-align: center;
  }
  #code + button{
    width: 4.875rem;
    height: 1.5625rem;
    line-height: 1.4375rem;
    border: 1px solid;
    border-radius: 0.75rem;
    background: transparent;
    font-size: 0.75rem;
    color: #FF9024;
  }
  #code + button:disabled{
    color: #7F7F7F;
  }
</style>